import React, { useEffect, useState } from "react";
import Logo from "../../../assets/images/Layer1.svg";
import { useLocation } from "react-router-dom";
import { Avatar } from "primereact/avatar";
import { GetAgentById } from "../../../api/auth.api";
import { Badge } from "primereact/badge";
import axios from "axios";
import { apiUrl, yeldamwebimagessas } from "../../../config/constants";
import Blobimages from "../../../assets/images/Blobimages/Blobimages";
import "./sidenav.components.css";
import shop from "../../../assets/icons/shop.svg";
import Rejected from './../../../pages/restaurants/rejected-restaurants/rejected-restaurants';

const Navbar = () => {
  const location = useLocation();
  const [agentData, setAgentdata] = useState<any>({});
  const [agentImage, setAgentimage] = useState(String);

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");
  const [isRDropdownOpen, setIsRDropdownOpen] = useState(splitLocation[1] === "restaurants");
  const [isFDropdownOpen, setIsFDropdownOpen] = useState(splitLocation[1] === "foodevents");
  const [isODropdownOpen, setIsODropdownOpen] = useState(splitLocation[1] === "organicstores");
  const [isdietitianOpen, setIsDietitianOpen] = useState(splitLocation[1] === "dietitian");

  const handleRDropdownToggle = () => {
    setIsRDropdownOpen(!isRDropdownOpen);
  };
  const handleFDropdownToggle = () => {
    setIsFDropdownOpen(!isFDropdownOpen);
  };
  const handleODropdownToggle = () => {
    setIsODropdownOpen(!isODropdownOpen);
  };
  const handleDietdropDownToggle = () => {
    setIsDietitianOpen(!isdietitianOpen);
  }

  // console.log(splitLocation);
  const logout = () => {
    localStorage.clear(); //for localStorage
    sessionStorage.clear(); //for sessionStorage
  };

  const loadLazyData = async () => {
    //imitate delay of a backend call
    const token = localStorage.getItem("accessToken");

    const headers = {
      Accept: "*/*",
      Authorization: "Bearer " + token,
    };
    await axios
      .get(apiUrl + "/agent/getagentbyid", { headers })
      .then((res) => {
        // then print response status
        // console.warn(res.data.data);
        // console.log("inside sidenav",res.data.data)
        setAgentdata(res.data.data);
        setAgentimage(res.data.data.image);
      })
      .catch((err) => {
        console.log("err in get agent by id", err);
      });
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;

    const delayedFetch = () => {
      // Add a delay of 500ms before making the API call
      timer = setTimeout(() => {
        loadLazyData();
      }, 500);
    };
    delayedFetch();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <div className="yeldam-agent-header">
        <a className="fs-20 fw-700 yeldam-logo-link" href="/dashboard">
          <img
            src={Blobimages.mainlogo + "?" + yeldamwebimagessas}
            alt="yeldam Logo"
            className="site-logo"
          />
        </a>{" "}
        <button
          aria-label="Toggle navigation"
          className="navbar-toggler border-0 ms-auto"
          data-bs-target="#offcanvasNavbar"
          data-bs-toggle="offcanvas"
          type="button"
        >
          <i className="pi pi-bars"></i>
        </button>
      </div>
      <aside
        aria-hidden="true"
        aria-labelledby="offcanvasNavbarLabel"
        className="yeldam_left_nav d-flex flex-column flex-shrink-0 offcanvas offcanvas-start"
        id="offcanvasNavbar"
        tabIndex={-1}
      >
        <a className="fs-20 fw-700 yeldam-logo-link" href="/dashboard">
          <img
            src={Blobimages.mainlogo + "?" + yeldamwebimagessas}
            alt="yeldam Logo"
            className="site-logo"
          />
        </a>
        <nav className="nav flex-column yeldam_nav_links mb-auto">
          <a
            className={
              splitLocation[1] === "dashboard"
                ? "nav-link active d-flex gap-2 align-items-center"
                : "nav-link d-flex gap-2 align-items-center"
            }
            href="/dashboard"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 1V4H1L1 1H6ZM1 0C0.447715 0 0 0.447715 0 1V4C0 4.55228 0.447715 5 1 5H6C6.55228 5 7 4.55228 7 4V1C7 0.447715 6.55228 0 6 0H1Z"
                fill="#818181"
              />
              <path
                d="M15 12V15H10V12H15ZM10 11C9.44772 11 9 11.4477 9 12V15C9 15.5523 9.44772 16 10 16H15C15.5523 16 16 15.5523 16 15V12C16 11.4477 15.5523 11 15 11H10Z"
                fill="#818181"
              />
              <path
                d="M6 8V15H1L1 8H6ZM1 7C0.447715 7 0 7.44772 0 8V15C0 15.5523 0.447715 16 1 16H6C6.55228 16 7 15.5523 7 15V8C7 7.44772 6.55228 7 6 7H1Z"
                fill="#818181"
              />
              <path
                d="M15 1V8H10V1H15ZM10 0C9.44772 0 9 0.447715 9 1V8C9 8.55229 9.44772 9 10 9H15C15.5523 9 16 8.55229 16 8V1C16 0.447715 15.5523 0 15 0H10Z"
                fill="#818181"
              />
            </svg>
            <span>Dashboard</span>
          </a>

          {/* Add Restaurants */}

          <a
            className={
              splitLocation[1] === "restaurants"
                ? "nav-link active d-flex gap-2 align-items-center"
                : "nav-link d-flex gap-2 align-items-center"
            }
            onClick={handleRDropdownToggle}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.97071 1.34921C3.16069 1.12756 3.43804 1 3.72997 1H12.27C12.562 1 12.8393 1.12756 13.0293 1.34921L15.6389 4.39374C15.8719 4.6656 16 5.01186 16 5.36992V5.625C16 6.93668 14.9367 8 13.625 8C12.8629 8 12.1846 7.64102 11.75 7.08291C11.3154 7.64102 10.6371 8 9.875 8C9.11287 8 8.43458 7.64102 8 7.08291C7.56542 7.64102 6.88714 8 6.125 8C5.36286 8 4.68458 7.64102 4.25 7.08291C3.81542 7.64102 3.13713 8 2.375 8C1.06332 8 0 6.93668 0 5.625V5.36992C0 5.01186 0.128088 4.6656 0.361115 4.39374L2.97071 1.34921ZM4.75 5.625C4.75 6.38439 5.36561 7 6.125 7C6.88439 7 7.5 6.38439 7.5 5.625C7.5 5.34886 7.72386 5.125 8 5.125C8.27614 5.125 8.5 5.34886 8.5 5.625C8.5 6.38439 9.11561 7 9.875 7C10.6344 7 11.25 6.38439 11.25 5.625C11.25 5.34886 11.4739 5.125 11.75 5.125C12.0261 5.125 12.25 5.34886 12.25 5.625C12.25 6.38439 12.8656 7 13.625 7C14.3844 7 15 6.38439 15 5.625V5.36992C15 5.25057 14.9573 5.13515 14.8796 5.04453L12.27 2H3.72997L1.12037 5.04453C1.0427 5.13515 1 5.25057 1 5.36992V5.625C1 6.38439 1.61561 7 2.375 7C3.13439 7 3.75 6.38439 3.75 5.625C3.75 5.34886 3.97386 5.125 4.25 5.125C4.52614 5.125 4.75 5.34886 4.75 5.625ZM1.5 8.5C1.77614 8.5 2 8.72386 2 9V15H3V10C3 9.44772 3.44772 9 4 9H7C7.55228 9 8 9.44772 8 10V15H14V9C14 8.72386 14.2239 8.5 14.5 8.5C14.7761 8.5 15 8.72386 15 9V15H15.5C15.7761 15 16 15.2239 16 15.5C16 15.7761 15.7761 16 15.5 16H0.5C0.223858 16 0 15.7761 0 15.5C0 15.2239 0.223858 15 0.5 15H1V9C1 8.72386 1.22386 8.5 1.5 8.5ZM4 15H7V10H4V15ZM9 10C9 9.44772 9.44771 9 10 9H12C12.5523 9 13 9.44772 13 10V13C13 13.5523 12.5523 14 12 14H10C9.44771 14 9 13.5523 9 13V10ZM12 10H10V13H12V10Z"
                fill="#36A41D"
              />
            </svg>

            <span>Restaurants</span>
            <i
              className={`pi ${isRDropdownOpen ? "pi-angle-up" : "pi-angle-down"
                }`}
              style={{ fontSize: "1rem", marginLeft:"auto", color: "#818181" }}
            ></i>
          </a>
          {isRDropdownOpen && (
            <div className="submenu">
              <a
                className={
                  splitLocation[2] === "addrestaurant" ? "nav-link active" : "nav-link"
                }
                href="/restaurants/addrestaurant"
              >
                <span> Add Restaurant</span>
              </a>
              <a
                className={
                  splitLocation[2] === "pending" ? "nav-link active" : "nav-link"
                }
                href="/restaurants/pending"
              >
                <span> Pending Restaurants</span>
              </a>
              <a
                className={
                  splitLocation[2] === "approved" ? "nav-link active" : "nav-link"
                }
                href="/restaurants/approved"
              >
                <span> Approved Restaurants</span>
              </a>
              <a
                className={
                  splitLocation[2] === "rejected" ? "nav-link active" : "nav-link"
                }
                href="/restaurants/rejected"
              >
                <span> Rejected Restaurants</span>
              </a>
            </div>
          )}


          <a
            className={
              splitLocation[1] === "organicstores"
                ? "nav-link active d-flex gap-2 align-items-center"
                : "nav-link d-flex gap-2 align-items-center"
            }
            onClick={handleODropdownToggle}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8536 8.14645C11.0488 8.34171 11.0488 8.65829 10.8536 8.85355L7.85355 11.8536C7.75979 11.9473 7.63261 12 7.5 12C7.36739 12 7.24021 11.9473 7.14645 11.8536L5.64645 10.3536C5.45118 10.1583 5.45118 9.84171 5.64645 9.64645C5.84171 9.45118 6.15829 9.45118 6.35355 9.64645L7.5 10.7929L10.1464 8.14645C10.3417 7.95118 10.6583 7.95118 10.8536 8.14645Z"
                fill="#818181"
              />
              <path
                d="M3.5 0C3.77614 0 4 0.223858 4 0.5V1H12V0.5C12 0.223858 12.2239 0 12.5 0C12.7761 0 13 0.223858 13 0.5V1H14C15.1046 1 16 1.89543 16 3V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V3C0 1.89543 0.895431 1 2 1H3V0.5C3 0.223858 3.22386 0 3.5 0ZM2 2C1.44772 2 1 2.44772 1 3V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V3C15 2.44772 14.5523 2 14 2H2Z"
                fill="#818181"
              />
              <path
                d="M2.5 4C2.5 3.72386 2.72386 3.5 3 3.5H13C13.2761 3.5 13.5 3.72386 13.5 4V5C13.5 5.27614 13.2761 5.5 13 5.5H3C2.72386 5.5 2.5 5.27614 2.5 5V4Z"
                fill="#818181"
              />
            </svg>
            {/* Add Organic Store */}
            <span>Organic Store</span>
            <i
              className={`pi ${isODropdownOpen ? "pi-angle-up" : "pi-angle-down"
                }`}
              style={{ fontSize: "1rem", marginLeft:"auto", color: "#818181" }}
            ></i>
          </a>
          {isODropdownOpen && (
            <div className="submenu">
              <a
                className={
                  splitLocation[2] === "addorgaincstore"
                    ? "nav-link active"
                    : "nav-link"
                }
                href="/organicstores/addorgaincstore"
              >
                <span>Add Organic Store</span>
              </a>
              <a
                className={
                  splitLocation[2] === "pendingstore" ? "nav-link active" : "nav-link"
                }
                href="/organicstores/pendingstore"
              >
                <span>Pending Organic Stores</span>
              </a>
              <a
                className={
                  splitLocation[2] === "approvedstore" ? "nav-link active" : "nav-link"
                }
                href="/organicstores/approvedstore"
              >
                <span>Approved Organic Stores</span>
              </a>
              <a
                className={
                  splitLocation[2] === "rejectedstore" ? "nav-link active" : "nav-link"
                }
                href="/organicstores/rejectedstore"
              >
                <span>Rejected Organic Stores</span>
              </a>


            </div>
          )}

          {/* Dietitians */}
          <a
            className={
              splitLocation[1] === "dietitians"
                ? "nav-link active d-flex gap-2 align-items-center"
                : "nav-link d-flex gap-2 align-items-center"
            }
            onClick={handleDietdropDownToggle}
          >
            <svg xmlns="http://www.w3.org/2000/svg"
              width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clip-path="url(#clip0_1243_5673)">
                <path d="M15.9758 15.3829L14.9191 12.2126C14.59 11.2256 13.7547 10.4722 12.739 10.2465L9.975 9.63225V8.44578C11.1739 7.75841 11.9833 6.46572 11.9833 4.9875V3.04928C11.9833 2.57956 11.8281 2.11391 11.5463 1.73809L11.5442 1.73534C11.1875 1.26047 10.0742 0 8.00028 0C5.92631 0 4.81312 1.25962 4.45578 1.73534L4.45372 1.73809C4.17187 2.11391 4.01665 2.57956 4.01665 3.04928V4.9875C4.01665 6.46572 4.82609 7.75841 6.025 8.44578V9.63225L3.26097 10.2465C2.24531 10.4722 1.40997 11.2256 1.08093 12.2126L0.0241843 15.3829C-0.0576907 15.6285 0.0750593 15.894 0.320653 15.9758C0.566309 16.0577 0.831716 15.9249 0.913591 15.6794L1.97034 12.5091C2.19581 11.8326 2.76831 11.3163 3.46437 11.1617L4.01668 11.0389V13.1311C3.43372 13.3274 3.01253 13.8788 3.01253 14.5271C3.01253 15.3393 3.67328 16 4.48543 16C5.29759 16 5.95834 15.3393 5.95834 14.5271C5.95834 13.8788 5.53715 13.3274 4.95418 13.1311V10.8306L6.26443 10.5394L7.59806 12.76C7.68278 12.9012 7.83534 12.9875 8 12.9875C8.16465 12.9875 8.31722 12.9011 8.40193 12.76L9.7344 10.5392L11.0458 10.8306V12.106C10.5796 12.219 9.53956 12.7472 9.53956 14.0251V15.5312C9.53956 15.7901 9.74943 16 10.0083 16H10.5104C10.7693 16 10.9792 15.7901 10.9792 15.5312C10.9792 15.2724 10.7693 15.0625 10.5104 15.0625H10.4771V14.025C10.4771 13.4518 10.9409 12.9875 11.5146 12.9875C12.0867 12.9875 12.5521 13.4529 12.5521 14.025V15.0625H12.5187C12.2599 15.0625 12.05 15.2724 12.05 15.5312C12.05 15.7901 12.2599 16 12.5187 16H13.0208C13.2797 16 13.4896 15.7901 13.4896 15.5312V14.025C13.4896 13.0975 12.8467 12.3177 11.9833 12.1067V11.0389L12.5356 11.1616C13.2317 11.3163 13.8042 11.8326 14.0297 12.509L15.0864 15.6793C15.1683 15.9249 15.4337 16.0576 15.6793 15.9758C15.9249 15.894 16.0577 15.6285 15.9758 15.3829ZM5.02081 14.5271C5.02081 14.8223 4.78062 15.0625 4.4854 15.0625C4.19018 15.0625 3.95 14.8223 3.95 14.5271C3.95 14.2318 4.19018 13.9917 4.4854 13.9917C4.78062 13.9917 5.02081 14.2318 5.02081 14.5271ZM4.95415 3.04928C4.95415 2.78191 5.04222 2.51688 5.20222 2.30259C5.20278 2.30187 5.20331 2.30116 5.20384 2.30044C5.48803 1.92153 6.355 0.9375 8.00462 0.9375C9.64709 0.9375 10.5167 1.92775 10.7962 2.30044C10.7967 2.30116 10.7972 2.30187 10.7978 2.30259C10.9577 2.51684 11.0458 2.78191 11.0458 3.04928V3.85584L10.4005 3.21056C10.3032 3.11319 10.2024 3.0125 10.0083 3.0125C9.9355 3.0125 9.86375 3.02944 9.79865 3.062C8.6724 3.62512 7.32762 3.62512 6.20131 3.062C6.02084 2.97169 5.80287 3.00709 5.66025 3.14981L4.95418 3.85516L4.95415 3.04928ZM4.95415 4.9875V4.88791C5.2234 4.81016 5.47025 4.66556 5.67397 4.46191C5.81325 4.32259 5.96915 4.16672 6.09315 4.04272C7.30865 4.5475 8.69128 4.54756 9.90684 4.04272L10.3261 4.46194C10.5297 4.66559 10.7766 4.81016 11.0458 4.88791V4.9875C11.0458 6.66697 9.67947 8.03334 8 8.03334C6.32053 8.03334 4.95415 6.66697 4.95415 4.9875ZM9.0375 9.8785L8 11.6077L6.9625 9.87847V8.83347C7.29343 8.92284 7.64122 8.97081 8 8.97081C8.35878 8.97081 8.70656 8.92284 9.0375 8.83347V9.8785Z" fill="#36A41D" />
              </g>
              <defs>
                <clipPath id="clip0_1243_5673">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <span>Dietitians</span>
            <i
              className={`pi ${isdietitianOpen ? "pi-angle-up" : "pi-angle-down"
                }`}
              style={{ fontSize: "1rem", marginLeft:"auto", color: "#818181" }}
            ></i>
          </a>
          {isdietitianOpen && (
           <div className="submenu">
           <a
             className={
               splitLocation[2] === "adddietitian"
                 ? "nav-link active"
                 : "nav-link"
             }
             href="/dietitian/adddietitian"
           >
             <span>Add Dietitian</span>
           </a>
           <a
             className={
               splitLocation[2] === "pendingdietitian" ? "nav-link active" : "nav-link"
             }
             href="/dietitian/pendingdietitian"
           >
             <span>Pending Dietitians</span>
           </a>
           <a
             className={
               splitLocation[2] === "approveddietitian" ? "nav-link active" : "nav-link"
             }
             href="/dietitian/approveddietitian"
           >
             <span>Approved Dietitians</span>
           </a>
           <a
             className={
               splitLocation[2] === "rejecteddietitian" ? "nav-link active" : "nav-link"
             }
             href="/dietitian/rejecteddietitian"
           >
             <span>Rejected Dietitians</span>
           </a>


         </div>
          )

          }

          {/* Add Foodd events */}
          {/* <a
            className={
              splitLocation[1] === "foodevents"
                ? "nav-link active d-flex gap-2 align-items-center"
                : "nav-link d-flex gap-2 align-items-center"
            }
            onClick={handleFDropdownToggle}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8536 8.14645C11.0488 8.34171 11.0488 8.65829 10.8536 8.85355L7.85355 11.8536C7.75979 11.9473 7.63261 12 7.5 12C7.36739 12 7.24021 11.9473 7.14645 11.8536L5.64645 10.3536C5.45118 10.1583 5.45118 9.84171 5.64645 9.64645C5.84171 9.45118 6.15829 9.45118 6.35355 9.64645L7.5 10.7929L10.1464 8.14645C10.3417 7.95118 10.6583 7.95118 10.8536 8.14645Z"
                fill="#818181"
              />
              <path
                d="M3.5 0C3.77614 0 4 0.223858 4 0.5V1H12V0.5C12 0.223858 12.2239 0 12.5 0C12.7761 0 13 0.223858 13 0.5V1H14C15.1046 1 16 1.89543 16 3V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V3C0 1.89543 0.895431 1 2 1H3V0.5C3 0.223858 3.22386 0 3.5 0ZM2 2C1.44772 2 1 2.44772 1 3V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V3C15 2.44772 14.5523 2 14 2H2Z"
                fill="#818181"
              />
              <path
                d="M2.5 4C2.5 3.72386 2.72386 3.5 3 3.5H13C13.2761 3.5 13.5 3.72386 13.5 4V5C13.5 5.27614 13.2761 5.5 13 5.5H3C2.72386 5.5 2.5 5.27614 2.5 5V4Z"
                fill="#818181"
              />
            </svg>

            <span>Food Events</span>
            <i
              className={`pi ${isFDropdownOpen ? "pi-angle-up" : "pi-angle-down"
                }`}
              style={{ fontSize: "1rem", marginLeft:"auto", color: "#818181" }}
            ></i>
          </a>
          {isFDropdownOpen && (
            <div className="submenu">
              <a
                className={
                  splitLocation[2] === "addevent" ? "nav-link active" : "nav-link"
                }
                href="/foodevents/addevent"
              >
                <span>Add Food Events</span>

              </a>
              <a
                className={
                  splitLocation[2] === "pendingevent" ? "nav-link active" : "nav-link"
                }
                href="/foodevents/pendingevent"
              >
                <span>Pending Food Events</span>

              </a>
              <a
                className={
                  splitLocation[2] === "approvedevent" ? "nav-link active" : "nav-link"
                }
                href="/foodevents/approvedevent"
              >
                <span>Approved Food Events</span>

              </a>
              <a
                className={
                  splitLocation[2] === "rejectedevent" ? "nav-link active" : "nav-link"
                }
                href="/foodevents/rejectedevent"
              >
                <span>Rejected Food Events</span>

              </a>
            </div>
          )} */}




          <a
            className={
              splitLocation[1] === "usersuggested"
                ? "nav-link active d-flex gap-2 align-items-center"
                : "nav-link d-flex gap-2 align-items-center"
            }
            href="/usersuggested"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M15.9132 3.58837L13.972 1.59219C13.9146 1.53368 13.8371 1.5 13.7554 1.5H2.24591C2.16412 1.5 2.08668 1.5328 2.02926 1.59219L0.0881039 3.58837C0.00196583 3.67701 -0.0241366 3.81086 0.0237179 3.92609C0.0707023 4.04132 0.182073 4.11666 0.304754 4.11666H0.972107V5.30799C0.972107 5.9205 1.24792 6.46829 1.67948 6.82995V13.7022H1.72299C1.55506 13.7022 1.39149 13.93 1.39149 14.1011C1.39149 14.2722 1.52809 14.5 1.69602 14.5H14.4775C14.6454 14.5 14.782 14.2722 14.782 14.1011C14.782 13.93 14.6454 13.7022 14.4775 13.7022H14.3209V6.90884C14.8108 6.55162 15.1318 5.96748 15.1318 5.30799V4.11666H15.6956C15.8183 4.11666 15.9297 4.04132 15.9767 3.92609C16.0237 3.81086 15.9993 3.67701 15.9132 3.58837ZM1.84219 5.30799V4.11666H4.49072V5.30799C4.49072 6.05168 3.89645 6.6571 3.16645 6.6571C2.43646 6.6571 1.84219 6.05168 1.84219 5.30799ZM9.93945 13.7022H6.06094V10.5537C6.06094 10.5537 7.41003 10.5273 8.02344 10.5273C8.63685 10.5273 9.93858 10.5537 9.93858 10.5537L9.93945 13.7022ZM13.4508 13.7022H10.7225V10.2878C10.7225 9.55878 8.94989 9.67425 8.00063 9.67425C7.05137 9.67425 5.27874 9.55053 5.27874 10.2878V13.7022H2.55044V7.52755C2.74446 7.59403 2.95154 7.63214 3.16732 7.63214C3.85121 7.63214 4.45244 7.26694 4.79612 6.71915C5.1398 7.26694 5.74103 7.63214 6.42491 7.63214C7.10879 7.63214 7.71002 7.26694 8.0537 6.71915C8.39739 7.26694 8.99861 7.63214 9.6825 7.63214C10.3664 7.63214 10.9676 7.26694 11.3113 6.71915C11.655 7.26694 12.2562 7.63214 12.9401 7.63214C13.1176 7.63214 13.289 7.60555 13.4526 7.55946V13.7022H13.4508ZM5.09891 5.30799V4.11666H7.74744V5.30799C7.74744 6.05168 7.15317 6.6571 6.42317 6.6571C5.69317 6.6571 5.09891 6.05168 5.09891 5.30799ZM8.35649 5.30799V4.11666H11.005V5.30799C11.005 6.05168 10.4108 6.6571 9.68076 6.6571C8.95076 6.6571 8.35649 6.05168 8.35649 5.30799ZM14.2617 5.30799C14.2617 6.05168 13.6675 6.6571 12.9375 6.6571C12.2075 6.6571 11.6132 6.05168 11.6132 5.30799V4.11666H14.2617V5.30799ZM1.29404 3.3189L2.3712 2.20912H13.6274L14.7046 3.3189H1.29404Z" fill="#36A41D" />
            </svg>
            <span>User Suggested</span>

          </a>

        </nav>
        <nav className="nav yeldam_nav_links">
          {/* <a className={splitLocation[1] === "users" ? "nav-link active" : "nav-link"} href="/users"><i className="pi pi-people"></i><span>Manage Users</span></a>
        <a className={splitLocation[1] === "settings" ? "nav-link active" : "nav-link"} href="/settings"><i className="pi pi-gear"></i><span>Settings</span></a>  */}

          <a
            className={
              splitLocation[1] === "profile"
                ? "nav-link active w-full p-link flex align-items-center"
                : "nav-link w-full p-link flex align-items-center"
            }
            href="/profile"
          >
            {/* <img src="https://appstack.bootlab.io/img/avatars/avatar.jpg" className="avatar img-fluid rounded-circle me-2" alt="Chris Wood"></img> */}
            {/* <Avatar image="https://appstack.bootlab.io/img/avatars/avatar.jpg" className="mr-2" size="large" shape="circle" /> */}

            {!agentImage || agentImage.length < 1 ? (
              <>
                <Avatar
                  icon="pi pi-user"
                  className="p-overlay-badge"
                  shape="circle"
                >
                  <Badge severity="success" />
                </Avatar>
              </>
            ) : (
              <>
                <Avatar
                  image={agentImage}
                  className="p-overlay-badge"
                  shape="circle"
                >
                  <Badge severity="success" />
                </Avatar>
              </>
            )}
            <div className="flex flex-column align center">
              <span className="ml-3" style={{ fontWeight: "400" }}> {agentData?.name}</span>
              {/* <span className="text-sm ml-3">Agent</span> */}
            </div>
          </a>

          <a
            className="nav-link yeldam-nav-bottom-link"
            href="/"
            onClick={logout}
          >
            <i className="pi pi-sign-out" style={{ fontSize: "1rem" }}></i>
            <span>Log out</span>
          </a>
        </nav>
      </aside>
    </div>
  );
};
export default Navbar;
